/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LicenseFieldsFragment = { __typename?: 'LicenseModel', license_id: string, name: string };

export type AccountSettingFieldsFragment = { __typename?: 'AccountSettingModel', license_id: string, account_id: string, branding_logo_url?: string | null, branding_color_primary?: string | null, branding_color_secondary?: string | null, is_patient_mfa_required: boolean, is_practitioner_mfa_required: boolean, account_user_added_email_notifications_enabled: boolean, medly_enabled: boolean, license?: { __typename?: 'LicenseModel', license_id: string, name: string, enabled_branding: boolean, enabled_patient_comms: boolean } | null };

export type ListLicensesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListLicensesQuery = { __typename?: 'Query', listLicenses: Array<{ __typename?: 'LicenseModel', limit_practitioners?: number | null, enabled_assessments: boolean, enabled_branding: boolean, enabled_patient_comms: boolean, license_id: string, name: string }> };

export type GetAccountSettingQueryVariables = Types.Exact<{
  input: Types.GetAccountSettingInput;
}>;


export type GetAccountSettingQuery = { __typename?: 'Query', getAccountSetting?: { __typename?: 'AccountSettingModel', license_id: string, account_id: string, branding_logo_url?: string | null, branding_color_primary?: string | null, branding_color_secondary?: string | null, is_patient_mfa_required: boolean, is_practitioner_mfa_required: boolean, account_user_added_email_notifications_enabled: boolean, medly_enabled: boolean, license?: { __typename?: 'LicenseModel', license_id: string, name: string, enabled_branding: boolean, enabled_patient_comms: boolean } | null } | null };

export type UpdateAccountSettingMutationVariables = Types.Exact<{
  input: Types.UpdateAccountSettingInput;
}>;


export type UpdateAccountSettingMutation = { __typename?: 'Mutation', updateAccountSetting: { __typename?: 'AccountSettingModel', license_id: string, account_id: string, branding_logo_url?: string | null, branding_color_primary?: string | null, branding_color_secondary?: string | null, is_patient_mfa_required: boolean, is_practitioner_mfa_required: boolean, account_user_added_email_notifications_enabled: boolean, medly_enabled: boolean, license?: { __typename?: 'LicenseModel', license_id: string, name: string, enabled_branding: boolean, enabled_patient_comms: boolean } | null } };

export type UpdateAccountUserAddedEmailNotificationSettingMutationVariables = Types.Exact<{
  input: Types.UpdateAccountUserAddedEmailNotificationSettingInput;
}>;


export type UpdateAccountUserAddedEmailNotificationSettingMutation = { __typename?: 'Mutation', updateAccountUserAddedEmailNotificationSetting: { __typename?: 'AccountSettingModel', license_id: string, account_id: string, branding_logo_url?: string | null, branding_color_primary?: string | null, branding_color_secondary?: string | null, is_patient_mfa_required: boolean, is_practitioner_mfa_required: boolean, account_user_added_email_notifications_enabled: boolean, medly_enabled: boolean, license?: { __typename?: 'LicenseModel', license_id: string, name: string, enabled_branding: boolean, enabled_patient_comms: boolean } | null } };

export type UpdateAccountLicenseMutationVariables = Types.Exact<{
  input: Types.UpdateAccountLicenseInput;
}>;


export type UpdateAccountLicenseMutation = { __typename?: 'Mutation', updateAccountLicense: { __typename?: 'AccountSettingModel', license_id: string, account_id: string, branding_logo_url?: string | null, branding_color_primary?: string | null, branding_color_secondary?: string | null, is_patient_mfa_required: boolean, is_practitioner_mfa_required: boolean, account_user_added_email_notifications_enabled: boolean, medly_enabled: boolean, license?: { __typename?: 'LicenseModel', license_id: string, name: string, enabled_branding: boolean, enabled_patient_comms: boolean } | null } };

export const LicenseFieldsFragmentDoc = gql`
    fragment LicenseFields on LicenseModel {
  license_id
  name
}
    `;
export const AccountSettingFieldsFragmentDoc = gql`
    fragment AccountSettingFields on AccountSettingModel {
  license_id
  account_id
  branding_logo_url
  branding_color_primary
  branding_color_secondary
  is_patient_mfa_required
  is_practitioner_mfa_required
  account_user_added_email_notifications_enabled
  medly_enabled
  license {
    license_id
    name
    enabled_branding
    enabled_patient_comms
  }
}
    `;
export const ListLicensesDocument = gql`
    query listLicenses {
  listLicenses {
    ...LicenseFields
    limit_practitioners
    enabled_assessments
    enabled_branding
    enabled_patient_comms
  }
}
    ${LicenseFieldsFragmentDoc}`;
export function useListLicensesQuery(baseOptions?: Apollo.QueryHookOptions<ListLicensesQuery, ListLicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLicensesQuery, ListLicensesQueryVariables>(ListLicensesDocument, options);
      }
export function useListLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLicensesQuery, ListLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLicensesQuery, ListLicensesQueryVariables>(ListLicensesDocument, options);
        }
// @ts-ignore
export function useListLicensesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListLicensesQuery, ListLicensesQueryVariables>): Apollo.UseSuspenseQueryResult<ListLicensesQuery, ListLicensesQueryVariables>;
export function useListLicensesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLicensesQuery, ListLicensesQueryVariables>): Apollo.UseSuspenseQueryResult<ListLicensesQuery | undefined, ListLicensesQueryVariables>;
export function useListLicensesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLicensesQuery, ListLicensesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLicensesQuery, ListLicensesQueryVariables>(ListLicensesDocument, options);
        }
export type ListLicensesQueryHookResult = ReturnType<typeof useListLicensesQuery>;
export type ListLicensesLazyQueryHookResult = ReturnType<typeof useListLicensesLazyQuery>;
export type ListLicensesSuspenseQueryHookResult = ReturnType<typeof useListLicensesSuspenseQuery>;
export type ListLicensesQueryResult = Apollo.QueryResult<ListLicensesQuery, ListLicensesQueryVariables>;
export const GetAccountSettingDocument = gql`
    query getAccountSetting($input: GetAccountSettingInput!) {
  getAccountSetting(input: $input) {
    ...AccountSettingFields
  }
}
    ${AccountSettingFieldsFragmentDoc}`;
export function useGetAccountSettingQuery(baseOptions: Apollo.QueryHookOptions<GetAccountSettingQuery, GetAccountSettingQueryVariables> & ({ variables: GetAccountSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountSettingQuery, GetAccountSettingQueryVariables>(GetAccountSettingDocument, options);
      }
export function useGetAccountSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountSettingQuery, GetAccountSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountSettingQuery, GetAccountSettingQueryVariables>(GetAccountSettingDocument, options);
        }
// @ts-ignore
export function useGetAccountSettingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountSettingQuery, GetAccountSettingQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountSettingQuery, GetAccountSettingQueryVariables>;
export function useGetAccountSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountSettingQuery, GetAccountSettingQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountSettingQuery | undefined, GetAccountSettingQueryVariables>;
export function useGetAccountSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountSettingQuery, GetAccountSettingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountSettingQuery, GetAccountSettingQueryVariables>(GetAccountSettingDocument, options);
        }
export type GetAccountSettingQueryHookResult = ReturnType<typeof useGetAccountSettingQuery>;
export type GetAccountSettingLazyQueryHookResult = ReturnType<typeof useGetAccountSettingLazyQuery>;
export type GetAccountSettingSuspenseQueryHookResult = ReturnType<typeof useGetAccountSettingSuspenseQuery>;
export type GetAccountSettingQueryResult = Apollo.QueryResult<GetAccountSettingQuery, GetAccountSettingQueryVariables>;
export const UpdateAccountSettingDocument = gql`
    mutation updateAccountSetting($input: UpdateAccountSettingInput!) {
  updateAccountSetting(input: $input) {
    ...AccountSettingFields
  }
}
    ${AccountSettingFieldsFragmentDoc}`;
export type UpdateAccountSettingMutationFn = Apollo.MutationFunction<UpdateAccountSettingMutation, UpdateAccountSettingMutationVariables>;
export function useUpdateAccountSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountSettingMutation, UpdateAccountSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountSettingMutation, UpdateAccountSettingMutationVariables>(UpdateAccountSettingDocument, options);
      }
export type UpdateAccountSettingMutationHookResult = ReturnType<typeof useUpdateAccountSettingMutation>;
export type UpdateAccountSettingMutationResult = Apollo.MutationResult<UpdateAccountSettingMutation>;
export type UpdateAccountSettingMutationOptions = Apollo.BaseMutationOptions<UpdateAccountSettingMutation, UpdateAccountSettingMutationVariables>;
export const UpdateAccountUserAddedEmailNotificationSettingDocument = gql`
    mutation updateAccountUserAddedEmailNotificationSetting($input: UpdateAccountUserAddedEmailNotificationSettingInput!) {
  updateAccountUserAddedEmailNotificationSetting(input: $input) {
    ...AccountSettingFields
  }
}
    ${AccountSettingFieldsFragmentDoc}`;
export type UpdateAccountUserAddedEmailNotificationSettingMutationFn = Apollo.MutationFunction<UpdateAccountUserAddedEmailNotificationSettingMutation, UpdateAccountUserAddedEmailNotificationSettingMutationVariables>;
export function useUpdateAccountUserAddedEmailNotificationSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountUserAddedEmailNotificationSettingMutation, UpdateAccountUserAddedEmailNotificationSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountUserAddedEmailNotificationSettingMutation, UpdateAccountUserAddedEmailNotificationSettingMutationVariables>(UpdateAccountUserAddedEmailNotificationSettingDocument, options);
      }
export type UpdateAccountUserAddedEmailNotificationSettingMutationHookResult = ReturnType<typeof useUpdateAccountUserAddedEmailNotificationSettingMutation>;
export type UpdateAccountUserAddedEmailNotificationSettingMutationResult = Apollo.MutationResult<UpdateAccountUserAddedEmailNotificationSettingMutation>;
export type UpdateAccountUserAddedEmailNotificationSettingMutationOptions = Apollo.BaseMutationOptions<UpdateAccountUserAddedEmailNotificationSettingMutation, UpdateAccountUserAddedEmailNotificationSettingMutationVariables>;
export const UpdateAccountLicenseDocument = gql`
    mutation updateAccountLicense($input: UpdateAccountLicenseInput!) {
  updateAccountLicense(input: $input) {
    ...AccountSettingFields
  }
}
    ${AccountSettingFieldsFragmentDoc}`;
export type UpdateAccountLicenseMutationFn = Apollo.MutationFunction<UpdateAccountLicenseMutation, UpdateAccountLicenseMutationVariables>;
export function useUpdateAccountLicenseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountLicenseMutation, UpdateAccountLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountLicenseMutation, UpdateAccountLicenseMutationVariables>(UpdateAccountLicenseDocument, options);
      }
export type UpdateAccountLicenseMutationHookResult = ReturnType<typeof useUpdateAccountLicenseMutation>;
export type UpdateAccountLicenseMutationResult = Apollo.MutationResult<UpdateAccountLicenseMutation>;
export type UpdateAccountLicenseMutationOptions = Apollo.BaseMutationOptions<UpdateAccountLicenseMutation, UpdateAccountLicenseMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListLicenses = withQueryResponseHandler(useListLicensesQuery);
export const useGetAccountSetting = withQueryResponseHandler(useGetAccountSettingQuery);
export const useUpdateAccountSetting = withMutationResponseHandler(useUpdateAccountSettingMutation, "updateAccountSetting");
export const useUpdateAccountUserAddedEmailNotificationSetting = withMutationResponseHandler(useUpdateAccountUserAddedEmailNotificationSettingMutation, "updateAccountUserAddedEmailNotificationSetting");
export const useUpdateAccountLicense = withMutationResponseHandler(useUpdateAccountLicenseMutation, "updateAccountLicense");